import logger from '../../log';
import getIceCandidatesFromWebrtc from './getIceCandidatesFromWebrtc';
import toIceCandidates from './toIceCandidates';
import { GatherArgs } from '../interfaces';

const log = logger.getLogger(__filename);

/**
 * use the passed in getIceCandidates, the iceCandidates passed in,
 * or try to get the ice candidates from webrtc.
 * @param opts - the getIceCandidates function, iceCandidates, or
 * info to pass to the getIceCandidatesFromWebrtc function to find
 * the ice candidates.
 */
async function findIceCandidates(
  opts?: GatherArgs
): Promise<RTCIceCandidate[]> {
  if (opts?.getIceCandidates) {
    const iceCandidates = opts.getIceCandidates();
    if (iceCandidates.length > 0) {
      return iceCandidates;
    }
  }
  if (opts?.iceCandidates) {
    const iceCandidates = toIceCandidates(opts?.iceCandidates);
    log.debug('Received following iceCandidates at load', iceCandidates);
    if (iceCandidates.length > 0) {
      return iceCandidates;
    }
  }
  return getIceCandidatesFromWebrtc(opts);
}

export default findIceCandidates;
